import AxiosInstance from '../axios/AxiosInstance';

export const commandeService = {
  // Récupérer toutes les commandes du client connecté
  async getClientCommandes() {
    try {
      const clientId = localStorage.getItem('userId');
      const response = await AxiosInstance.get(`/order/client?clientId=${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des commandes:', error);
      throw error;
    }
  },

  // Récupérer une commande spécifique
  async getCommande(commandeId) {
    try {
      const response = await AxiosInstance.get(`/order/${commandeId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la commande:', error);
      throw error;
    }
  },

  // Créer une nouvelle commande avec infos auto-récupérées
  async createCommande(commandeData) {
    try {
      const response = await AxiosInstance.post('/order/client/auto', commandeData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la commande:', error);
      throw error;
    }
  },

  // Mettre à jour une commande avec infos auto-récupérées
  async updateCommande(commandeId, commandeData) {
    try {
      const response = await AxiosInstance.put(`/order/client/auto/${commandeId}`, commandeData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la commande:', error);
      throw error;
    }
  },

  // Supprimer une commande
  async deleteCommande(commandeId) {
    try {
      const response = await AxiosInstance.delete(`/order/${commandeId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la commande:', error);
      throw error;
    }
  },

  // Changer le statut d'une commande
  async updateCommandeStatus(commandeId, status) {
    try {
      const response = await AxiosInstance.patch(`/order/${commandeId}/status`, {
        status
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du changement de statut:', error);
      throw error;
    }
  },

  // Annuler une commande
  async cancelCommande(commandeId, reason) {
    try {
      const response = await AxiosInstance.post(`/order/${commandeId}/cancel`, {
        reason
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'annulation de la commande:', error);
      throw error;
    }
  }
};

export default commandeService;
